export default __webpack_public_path__ + "static/media/desktop.2a664044.jpg";